module.exports = __webpack_public_path__ + "static/media/console-error.bb5430bb.png";